import { ApiResponse } from 'apisauce';

import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import UtilFunctions from '~utils/functions';
import { TCreateDiscountSettingsAPIParams, TDiscountDetailsSettings, TGetDiscountSettingsAPIParams, TGetDiscountSettingsAPIResponse, TUpdateDiscountSettingsAPIParams } from '~types/feat/setting';
import { IDiscountGateway } from './discountBase';
import { TGetPendingDiscountListingReduxResponse } from '~types/feat/approval';

const { API: { getHeaders } } = UtilFunctions;

export default class DiscountGateway extends IDiscountGateway {

    async getDiscountsSettings(params: TGetDiscountSettingsAPIParams): GatewayResponse<TGetDiscountSettingsAPIResponse> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<TGetDiscountSettingsAPIResponse> = await this.api.get('/discount/getDiscountListing', restOfParams, getHeaders(authToken));
        return this.process(response);
    }

    async getDiscountsFilterSettings(params: ProtectedRoute): GatewayResponse<TDiscountDetailsSettings[]> {
        const { authToken } = params;
        const response: ApiResponse<TDiscountDetailsSettings[]> = await this.api.get('/discount/getDiscountFilter', {}, getHeaders(authToken));
        return this.process(response);
    }

    async createDiscountsSettings(params: TCreateDiscountSettingsAPIParams): GatewayResponse<string | null> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<string | null> = await this.api.post('/discount/createDiscount', restOfParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateDiscountsSettings(params: TUpdateDiscountSettingsAPIParams): GatewayResponse<string | null> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<string | null> = await this.api.put('/discount/editDiscount', restOfParams, getHeaders(authToken));
        return this.process(response);
    }

    async getDiscountChangeHistoryListing(params: TGetDiscountSettingsAPIParams): GatewayResponse<TGetPendingDiscountListingReduxResponse> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<TGetPendingDiscountListingReduxResponse> = await this.api.get('/discount/getDiscountChangeHistoryListing', restOfParams, getHeaders(authToken));
        return this.process(response);
    }
}
